import { render, staticRenderFns } from "./Figure.vue?vue&type=template&id=2221ad86&"
import script from "./Figure.vue?vue&type=script&lang=js&"
export * from "./Figure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports